/* eslint-disable no-restricted-imports -- It's ok in this file as it is exporting for the rest of the application */
export {
	bifrostEnv,
	bitbucketCommit,
	debugEnabled,
	getIdentityUrl,
	getRovoExtensionWebBaseUrl,
	getGraphqlUrl,
	getAtlassianHomeUrl,
	getAdminHubUrl,
	getStudioUrl,
	getLocale,
	getBuildInfo,
	getSessionReplayAmplitudeApiKey,
} from './config';
export { setLocalDevSessionCookie } from './dev-session-cookie';
